import React from "react";
import SlideItem from "../SlideItem";
import styles from "./SlideShow.module.css";

const SlideShow = ({ slides, currentSlide, isAnimating }) => {
  if (!slides || slides.length === 0) return null;

  return (
    <div className={styles.slideShow}>
      {slides.map((slide, index) => (
        <SlideItem
          key={slide.id}
          slide={slide}
          isActive={index === currentSlide}
          isVisible={index <= currentSlide}
        />
      ))}
    </div>
  );
};

export default SlideShow;
